export function assertNonNull<T>(val: T, message: string): asserts val is NonNullable<T> {
  if (val == null) {
    throw Error(message)
  }
}

/**
 * Filter predicate to remove empty values out of an array
 * while preserving strict type checking
 */
export function isNotNull<T>(value: T | null | undefined): value is T {
  return value != null
}
